import { lazyLoad } from 'utils/loadable';

export const SaleContactPage = lazyLoad(
  () => import('./index'),
  module => module.SaleContactPage
);
